import React, { useState, useRef, useEffect } from "react";
import Header from "parts/Header";
import { Fade } from "react-awesome-reveal";
import SirImage from "../assets/images/AwardsImages_SIR/main.jpeg";

import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Footer from "parts/Footer";
// import ImageOne from "../assets/images/Portfolio/Aura.png";
import ImageTwo from "../assets/images/AwardsImages_SIR/caro_2.jpeg";
import ImageFour from "../assets/images/AwardsImages_MAM/carousel_1.jpeg";
import { FaArrowRightLong } from "react-icons/fa6";

const FounderPersonOne = () => {
  const images = [ImageTwo, ImageFour];
  const [index, setIndex] = useState(0);
  const intervalRef = useRef(null);

  const startAutoSlide = () => {
    intervalRef.current = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
  };

  const stopAutoSlide = () => clearInterval(intervalRef.current);

  const prevSlide = () => {
    stopAutoSlide();
    setIndex((prev) => (prev - 1 + images.length) % images.length);
    startAutoSlide();
  };

  const nextSlide = () => {
    stopAutoSlide();
    setIndex((prev) => (prev + 1) % images.length);
    startAutoSlide();
  };

  useEffect(() => {
    startAutoSlide();
    return stopAutoSlide;
  }, []);

  return (
    <>
      <Header />
      {/* Content  */}
      <section className="flex flex-col lg:flex-row w-11/12 lg:w-11/12 pt-5 lg:pt-12 lg:mx-auto lg:items-start sm:items-center mx-auto">
        <div className="w-full sm:w-1/2 sm:pr-12">
          <Fade direction="up" triggerOnce>
            <img
              src={SirImage}
              alt="Hero"
              className="w-full h-[400px] object-contain  rounded-2xl"
            />
          </Fade>
        </div>

        <div className="w-full sm:w-1/2 flex flex-col pt-5 px-5 sm:mb-0 lg:mt-0">
          <Fade direction="up" triggerOnce>
            <h1 className="text-[34px] text-theme-blue font-bold leading-tight mb-5">
              Founder & MD's Message
            </h1>
          </Fade>
          <Fade direction="up" triggerOnce delay={400}>
            <p className="font-light text-xl text-gray-400 text-justify leading-relaxed">
              I am a first-generation entrepreneur who dared to defy the metro
              monopoly and ignite a tech revolution from the heart of Cuddalore.
              Scode Software Solutions became the beacon of that rebellion — the
              first to craft native iOS apps and AI Technology in a tier-3 city.
              We shattered norms by valuing brilliance over resumes and humanity
              over hierarchy. Our mission is to decentralize opportunity, uplift
              untapped talent, and make world-class tech careers local. This
              isn’t just a company — it’s a movement born from vision, grit, and
              the audacity to dream differently.
            </p>
          </Fade>
        </div>
      </section>

      {/* Achievements */}

      <section className="flex flex-col lg:flex-row w-11/12 lg:w-11/12  lg:pt-1 lg:mx-auto lg:items-start sm:items-center mx-auto">
        <div className="w-full sm:w-1/2 flex flex-col pt-12 px-5 sm:mb-0 lg:mt-0">
          <Fade direction="up" triggerOnce>
            <h1 className="text-[34px] text-theme-blue  text-center mb-5 font-bold leading-tight">
              Awards & Achievements
            </h1>
          </Fade>
          <Fade direction="up" triggerOnce delay={400}>
            <p className="font-light text-xl text-gray-400 leading-relaxed">
              I have consistently shown commitment and excellence in
              professional experiences, which has led to receiving multiple
              recognitions and achievements.
            </p>
          </Fade>
        </div>

        <div className="w-full sm:w-1/2 flex flex-col  px-5 sm:mb-0 lg:mt-0">
          <div className="max-w-3xl mx-auto mt-10 relative overflow-hidden">
            {/* Slide Container */}
            <div
              className="flex transition-transform duration-700 ease-in-out"
              style={{
                transform: `translateX(-${index * 100}%)`,
                width: `${images.length * 50}%`,
              }}
            >
              {images.map((src, i) => (
                <div
                  key={i}
                  className="min-w-full h-[300px] flex items-center  justify-center"
                  // Each slide takes 100% width
                >
                  <img
                    src={src}
                    alt={`Slide ${i + 1}`}
                    className="h-full object-cover"
                  />
                </div>
              ))}
            </div>

            {/* Controls */}
            {/* Controls */}
            {/* Prev Button */}
            <button
              onClick={prevSlide}
              disabled={index === 0}
              className={`absolute top-1/2 left-4 transform -translate-y-1/2 bg-white p-2 rounded-full shadow hover:bg-gray-200 transition-opacity duration-300 ${
                index === 0 ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <FaArrowLeft />
            </button>
            {/* Next Button */}
            <button
              onClick={nextSlide}
              disabled={index === images.length - 1}
              className={`absolute top-1/2 right-4 transform -translate-y-1/2 bg-white p-2 rounded-full shadow hover:bg-gray-200 transition-opacity duration-300 ${
                index === images.length - 1
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              <FaArrowRight />
            </button>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default FounderPersonOne;
